/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.v2.CopilotPreviewService
 */

/**
 *  Represents feedback provided for a copilot message.
 */

/**
 *  Response when preview is enqueued for generation.
 *  Contains Ably channel information and auth token for subscription.
 */

/**
 *  Response when preview messages are ready and immediately available.
 *  Contains the actual messages without requiring channel subscription.
 */

export const getOrCreatePreviewRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotPreviewService',
  rpcName: 'getOrCreatePreview',
  auth: 'app',
  fingerprint: '26tXjbKiaf9bVo9CDOazfiCZD64BBtPq',
  na1Only: false,
  isStreaming: false
};